import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft, Compass, AlertCircle } from "react-feather";
import BaseButton from "../../BaseComponents/BaseButton";
import "./notFound.css";

const NotFound = () => {
  const navigate = useNavigate();
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  
  // Generate particles once during initialization
  const [particles] = useState(() => 
    Array.from({ length: 20 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 4 + 2,
      duration: Math.random() * 10 + 15,
      delay: Math.random() * 5,
    }))
  );

  useEffect(() => {
    // Mouse move parallax effect
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 20;
      const y = (e.clientY / window.innerHeight - 0.5) * 20;
      setMousePosition({ x, y });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  const handleHome = () => {
    navigate("/");
  };

  return (
    <div className="not-found-container">
      {/* Animated Background */}
      <div className="not-found-bg">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      {/* Floating Particles */}
      <div className="particles-container">
        {particles.map((particle) => (
          <div
            key={particle.id}
            className="particle"
            style={{
              left: `${particle.x}%`,
              top: `${particle.y}%`,
              width: `${particle.size}px`,
              height: `${particle.size}px`,
              animationDuration: `${particle.duration}s`,
              animationDelay: `${particle.delay}s`,
            }}
          />
        ))}
      </div>

      {/* Main Content */}
      <div className="not-found-content">
        {/* Animated 404 Number */}
        <div
          className="error-code-wrapper"
          style={{
            transform: `translate(${mousePosition.x * 0.5}px, ${mousePosition.y * 0.5}px)`,
          }}
        >
          <div className="error-code">
            <span className="digit digit-1">4</span>
            <span className="digit digit-0">0</span>
            <span className="digit digit-2">4</span>
          </div>
          <div className="error-glow"></div>
        </div>

        {/* Text Content */}
        <div className="error-text-content">
          <h1 className="error-title">Page Not Found</h1>
          <p className="error-description">
            Oops! The page you&apos;re looking for seems to have wandered off into the digital void.
            <br />
            Don&apos;t worry, even the best explorers get lost sometimes.
          </p>

          {/* Action Buttons */}
          <div className="error-actions">
            <BaseButton
              className="btn btn-primary btn-lg error-btn"
              onClick={handleHome}
            >
              <Home size={18} />
              <span>Go Home</span>
            </BaseButton>
            <BaseButton
              className="btn btn-secondary btn-lg error-btn"
              onClick={handleBack}
            >
              <ArrowLeft size={18} />
              <span>Go Back</span>
            </BaseButton>
          </div>

          {/* Quick Links */}
          <div className="quick-links">
            <div className="quick-link-item" onClick={handleHome}>
              <Compass size={20} />
              <span>Dashboard</span>
            </div>
            <div className="quick-link-item" onClick={() => navigate("/help")}>
              <AlertCircle size={20} />
              <span>Help Center</span>
            </div>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="decorative-lines">
          <div className="line line-1"></div>
          <div className="line line-2"></div>
          <div className="line line-3"></div>
        </div>
      </div>

      {/* Animated Shapes */}
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
      </div>
    </div>
  );
};

export default NotFound;
